import { render, staticRenderFns } from "@/modules/Statement/templates/statements-list.html?vue&type=template&id=35c456b0&scoped=true&"
import script from "@/modules/Statement/scripts/statements-list.ts?vue&type=script&lang=js&"
export * from "@/modules/Statement/scripts/statements-list.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Statement/styles/statements-list.scss?vue&type=style&index=0&id=35c456b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c456b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VForm,VImg,VTooltip})
